export const employeeStatus = {
  AVAILABLE: "available",
  ASSIGNED: "assigned",
  UNAVAILABLE: "unavailable",
};
